<ion-list>
  <ion-item
    *ngFor="let service of externalTools"
    button
    lines="none"
    (click)="onGoToExternalService(service.url)"
  >
    <!-- <ion-avatar slot="start"> -->
    <ion-img slot="start" class="logo" [src]="service.logoUrl"></ion-img>
    <!-- </ion-avatar> -->

    <ion-label>{{ service.name }}</ion-label>
  </ion-item>
</ion-list>
